// extracted by mini-css-extract-plugin
module.exports = {"c1azn6l4":"c1azn6l4","n615bil":"n615bil"};